<template>
  <div class="fab-container">
    <div class="fab-parent fab-icon-holder">
      <i class="fa fa-chevron-up"></i>
    </div>
    <ul class="fab-options">
      <li
        v-if="
          checkPrivilege(
            usersEstablishmentPrivilegeData
              .usersPrivilegeCustodyExpenseOperations
              .custodyExpenseOperationsAddAll
          ) ||
          checkPrivilege(
            usersEstablishmentPrivilegeData
              .usersPrivilegeCustodyExpenseOperations
              .custodyExpenseOperationsAddSelf
          )
        "
      >
        <span class="fab-label">
          <router-link :to="{ name: 'CustodyExpenseOperationAdd' }" class="">
            {{ $t("CustodyExpenseOperations.add") }}
          </router-link>
        </span>
        <div class="fab-icon-holder">
          <router-link :to="{ name: 'CustodyExpenseOperationAdd' }" class="">
            <img src="@/assets/images/plus.svg" />
          </router-link>
        </div>
      </li>
      <li>
        <span class="fab-label" @click="open">
          {{ $t("filter") }}
        </span>
        <div class="fab-icon-holder" @click="open">
          <img src="@/assets/images/filter.svg" />
        </div>
      </li>
    </ul>

    <vue-bottom-sheet ref="CustomBottomSheet">
      <div class="row">
        <CustomInput
          :className="'col-md-12'"
          :id="'textSearch'"
          :value="filterData.textSearch"
          :title="$t('search')"
          :imgName="'search.svg'"
          v-on:changeValue="filterData.textSearch = $event"
        />

        <CustomSelectBox
          :className="'col-md-12'"
          :id="'custodyToken'"
          :value="filterData.custodyToken"
          :options="custodyTokenOptions"
          v-on:changeValue="filterData.custodyToken = $event"
          :title="$t('Custodies.select')"
          :imgName="'Custodies.svg'"
        />
        <CustomSelectBox
          :className="'col-md-12'"
          :id="'custodyExpenseToken'"
          :value="filterData.custodyExpenseToken"
          :options="custodyExpenseTokenOptions"
          v-on:changeValue="filterData.custodyExpenseToken = $event"
          :title="$t('CustodyExpenses.select')"
          :imgName="'CustodyExpenses.svg'"
        />
      </div>

      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="search"
        >
          {{ $t("search") }}
        </button>
        <button class="btn btn-cancel" @click.prevent="close">
          {{ $t("cancel") }}
        </button>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import { checkPrivilege } from "@/utils/functions";
import CustomInput from "@/components/general/CustomInput.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import { STATUS } from "@/utils/constants";
import Custodies from "@/models/finance/custodies/Custodies";
import CustodyExpenses from "@/models/settings/settingsOther/custodyExpenses/CustodyExpenses";
import privilegeMixin from "@/utils/privilege-mixin";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [privilegeMixin, createToastMixin],
  props: {
    theFilterData: {
      type: Object,
    },
  },
  data() {
    return {
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      filterData: this.theFilterData,
      custodies: new Custodies(),
      custodyTokenOptions: [],
      custodyExpenses: new CustodyExpenses(),
      custodyExpenseTokenOptions: [],
    };
  },
  components: {
    CustomInput,
    CustomSelectBox,
  },
  methods: {
    open() {
      this.$refs.CustomBottomSheet.open();
    },
    close() {
      this.$refs.CustomBottomSheet.close();
    },
    search() {
      this.close();
      this.$emit("search", this.filterData);
    },
    async getDialogOfCustodies() {
      this.isLoading = true;
      this.custodyTokenOptions = [];
      this.custodyTokenOptions.push({
        value: "",
        text: this.$t("Custodies.select"),
      });
      try {
        const response = await this.custodies.custody.getDialogOfCustodies(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.custodyTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfCustodyExpenses() {
      this.isLoading = true;
      this.custodyExpenseTokenOptions = [];
      this.custodyExpenseTokenOptions.push({
        value: "",
        text: this.$t("CustodyExpenses.select"),
      });
      try {
        const response =
          await this.custodyExpenses.custodyExpense.getDialogOfCustodyExpenses(
            this.language,
            this.userAuthorizeToken
          );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.custodyExpenseTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    checkPrivilege,
  },
  async created() {
    this.getDialogOfCustodies();
    this.getDialogOfCustodyExpenses();
  },
};
</script>
